import { LocalTypes } from '../types/SelectedJobAd';

export default {
    namespaced: true,
    state: {
        jobAdId: null,
        companyId: null,
    },
    getters: {},
    actions: {},
    mutations: {
        [LocalTypes.mutations.SET_JOB_AD]: (state, jobAdId) => {
            state.jobAdId = jobAdId;
        },
        [LocalTypes.mutations.SET_COMPANY_ID]: (state, companyId) => {
            state.companyId = companyId;
        },
    },
};
